import {Component, Input, OnInit} from '@angular/core';
import {GtNotificationService} from '@app/services/gt-notification.service';
import {GtConfigurationService, NameValueListType} from '@app/services/gt-configuration.service';
import {PhonenumberEntry} from '@app/models/phonenumber-entry';

export interface NameValueListEntry {
  name?: string;
  number?: string;
}

@Component({
  selector: 'gt-phone-number-list',
  templateUrl: './phone-number-list.component.html',
  styleUrls: ['./phone-number-list.component.scss']
})
export class PhoneNumberListComponent implements OnInit {
  @Input() orgName: string; // if undefined, the default value is organization from authService
  @Input() login: string; // if undefined, the default value is organization from authService
  @Input() canEdit = true;
  @Input() listType: NameValueListType; // if undefined, the default value is BLACKLIST_INCOMING
  nameValueListTypes = NameValueListType;
  phonenumberEntries: PhonenumberEntry[] = [];
  private entries: NameValueListEntry[];

  constructor(private configurationService: GtConfigurationService, private notificationService: GtNotificationService) {}

  ngOnInit() {
    this.configurationService.getNameValueList<NameValueListEntry>(this.listType, this.orgName, this.login).subscribe(list => {
      this.entries = list || [];
      this.setPhoneNumberEntryList();
    }, this.error);
  }

  removeNameValueListEntry(entry: PhonenumberEntry) {
    const newList = this.entries.filter(e => e.number !== entry.fullNumber);
    this.configurationService.setNameValueList<NameValueListEntry>(newList, this.listType, this.orgName, this.login).subscribe(
      () => {
        this.entries = newList;
      },
      e => {
        this.setPhoneNumberEntryList();
        this.error(e);
      }
    );
  }

  addNameValueListEntry(entry: PhonenumberEntry) {
    const newEntry = {enabled: true, number: entry.fullNumber, name: entry.name} as any;
    this.configurationService.addNameValueListEntry<NameValueListEntry>(newEntry, this.listType, this.orgName, this.login).subscribe(
      () => {
        this.entries.push(newEntry);
      },
      e => {
        this.setPhoneNumberEntryList();
        this.error(e);
      }
    );
  }

  private setPhoneNumberEntryList() {
    this.phonenumberEntries = this.entries.map(item => new PhonenumberEntry(item.number, item.name));
  }

  error = error => {
    this.notificationService.errorNotification.next(error);
  };
}
